import { cn } from './cn.js';

import type { ReactElement, ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

export function PageTransition({ children, className }: PageTransitionProps): ReactElement {
  return <div className={cn('page-enter', className)}>{children}</div>;
}
